import { useQuery } from "@tanstack/react-query";

import { exportDigitalAgronomistCropPractices } from "services";

import { EXPORT_DIGITAL_AGRONOMIST_CROP_PRACTICES } from "consts";

export const useExportDigitalAgronomistCropPractices = (countryCode: string) =>
  useQuery({
    queryKey: [EXPORT_DIGITAL_AGRONOMIST_CROP_PRACTICES, countryCode],
    queryFn: async ({ signal }) => {
      const response = await exportDigitalAgronomistCropPractices({ countryCode, signal });
      return response || [];
    },
    staleTime: 0,
    refetchOnWindowFocus: true, // making true as it was commented out for and defualt is being set as false (speak with alp about it)
    refetchOnMount: "always",
  });
